import { createStore } from "devextreme-aspnet-data-nojquery";
import DataSource from "devextreme/data/data_source";
import { setupRequestAsync } from "~/utils";
import { squireApiConfig } from "~/config";

const { url } = squireApiConfig;

export class ContactSelectorApiService {
  // Returns the bare store, for a grid <Lookup>, which rejects a DataSource instance (E1016).
  // InviteContactsGrid loads it directly; ClientContactsEditor takes the sorted wrapper below.
  getContactsByCompanyDataSource(companyId) {
    return createStore({
      key: "contactId",
      loadUrl: `${url}/v1/contact-selector/${companyId}/contacts`,
      onBeforeSend: async (method, ajaxOptions) =>
        await setupRequestAsync(method, ajaxOptions),
    });
  }

  getContactsByCompanyDataSourceSorted(companyId) {
    return new DataSource({
      store: this.getContactsByCompanyDataSource(companyId),
      sort: "fullName",
    });
  }
}
